import React from 'react'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import importImg from '../../../assets/web/import.png'
import editImg from '../../../assets/web/batch_edit.png'

const Box = styled.div`
  width: 8.9375rem;
  fontsize: 0.8125rem;
  color: var(--ow-text-color);
  border: 1px solid rgba(0, 0, 0, 0.1);
  ${tw`rounded-box flex flex-col items-center justify-center h-32 mr-3 cursor-pointer font-bold`}
  &:hover {
    border: 1px solid rgb(var(--ow-primary-color));
    color: rgb(var(--ow-primary-color));
  }
`
const SelAddType = function ({ updateAddType }) {
  return (
    <div className="w-full flex flex-row items-center mt-3">
      <Box
        onClick={() => {
          updateAddType('excel')
        }}
      >
        <img alt="" className="w-10 h-10 mb-4" src={importImg} />
        <span>从Excel中导入</span>
      </Box>
      <Box
        onClick={() => {
          updateAddType('text')
        }}
      >
        <img alt="" className="w-10 h-10 mb-4" src={editImg} />
        <span>文本编辑</span>
      </Box>
    </div>
  )
}
export default SelAddType
